import Crud from "../Crud";
import MUICyanColor from "@mui/material/colors/cyan";

/**
 * Static helper functions related to orderActivityTypes.
 */
export default class OrderActivityType extends Crud {
  /**
   * @param {object} orderActivityType The orderActivityType object.
   * @returns The display name of the orderActivityType.
   */
  static getDisplayName(orderActivityType) {
    return orderActivityType.name;
  }

  /**
   * Determines if an orderActivityType matches a search query.
   *
   * @param {object} orderActivityType The orderActivityType to test.
   * @param {string} query The search query.
   * @returns {boolean} Whether or not the orderActivityType matches the query.
   */
  static match(orderActivityType, query) {
    return (
      orderActivityType.name.toLowerCase().includes(query) ||
      orderActivityType.id === +query
    );
  }

  /**
   * @param {array} orderActivityTypes The list to sort.
   * @returns {array} The sorted list.
   */
  static sort(orderActivityTypes) {
    return orderActivityTypes.sort((a, b) => {
      return a.id - b.id;
    });
  }

  /**
   * Returns the icon name for this object or for a given orderActivityType string.
   * @param {string} [orderActivityType] Optional orderType string to get the icon for.
   * @returns {string} The icon name.
   */
  static getIconName(orderActivityType) {
    if (!orderActivityType) {
      return "Workspaces";
    }
    switch (true) {
      case orderActivityType.toLowerCase().includes("pickup"):
        return "Outbound";
      case orderActivityType.toLowerCase().includes("billing issue"):
        return "Paid";
      case orderActivityType.toLowerCase().includes("service"):
        return "BuildCircle";
      case orderActivityType.toLowerCase().includes("re-supply"):
        return "ChangeCircle";
      case orderActivityType.toLowerCase().includes("accessory after sale"):
        return "AddCircle";
      case orderActivityType.toLowerCase().includes("new"):
        return "FiberNew";
      default:
        return "Workspaces";
    }
  }

  /**
   * @returns {string} The color of this object.
   */
  static getBaseColor() {
    return MUICyanColor;
  }
}
